enum TransferType {
  REWARDS = "rewards"
}

export default TransferType
